import { render, staticRenderFns } from "./AiExtractClaimsModal.vue?vue&type=template&id=abebbbe8&scoped=true"
import script from "./AiExtractClaimsModal.vue?vue&type=script&lang=js"
export * from "./AiExtractClaimsModal.vue?vue&type=script&lang=js"
import style0 from "./AiExtractClaimsModal.vue?vue&type=style&index=0&id=abebbbe8&scoped=true&lang=scss"
import style1 from "./AiExtractClaimsModal.vue?vue&type=style&index=1&id=abebbbe8&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abebbbe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abebbbe8')) {
      api.createRecord('abebbbe8', component.options)
    } else {
      api.reload('abebbbe8', component.options)
    }
    module.hot.accept("./AiExtractClaimsModal.vue?vue&type=template&id=abebbbe8&scoped=true", function () {
      api.rerender('abebbbe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/AiExtractClaimsModal.vue"
export default component.exports